import { connect } from 'react-redux';
import { injectIntl } from "react-intl";
import ForgotPasswordConfirmation from './Confirmation';

export const ForgotPasswordConfirmationPage = injectIntl(connect()(ForgotPasswordConfirmation));